export const ANALYTICS_SECTIONS = {
  OVERVIEW: 'overview',
  CHECKLIST: 'checklist',
  DYNAMIC_PROMPT: 'deck',
  NOTIFICATIONS: 'notifications',
  POSTCALL: 'postcall',
  USAGE: 'usage',
  CSV: 'csv',
}

// Maps URL route param → internal section name (only needed where they differ)
export const ROUTE_TO_SECTION = {
  'dynamic-prompt': ANALYTICS_SECTIONS.DYNAMIC_PROMPT,
}

// Section names used by the CSV export API (postcall differs from analytics sections)
export const CSV_EXPORT_SECTIONS = {
  CHECKLIST: 'checklist',
  NOTIFICATIONS: 'notifications',
  POSTCALL: 'classified_postcall',
  DYNAMIC_PROMPT: 'deck',
}
